<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <GroupConfiguration
        :groupNameInputDisabled="false"
        :parentType="parentType"
      />
    </template>
  </DetailsAsideLayout>
</template>

<script>
import { ItemTypeConsts } from 'client/util/Constants';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import GroupConfiguration from 'client/groups/Components/GroupConfiguration.vue';

export default {
  name: 'ConfigurationGroupDetails',

  components: {
    GroupConfiguration,
    DetailsAsideLayout,
  },

  data() {
    return {
      parentType: ItemTypeConsts.configurationGroup,
    };
  },
};
</script>
